<template>
  <div>
    <h4>{{title}}</h4>
    <Bar 
      :chart-data="declaration"
      :height="height" />
  </div>
</template>

<script>

import Bar from '../../store/Graficos/BarChart'

export default {
  components: {
    Bar
  },
  data(){
    return {
      
    }
  },
  mounted () {
  },
  props:{
    title:{
      type: String
    },
    height:{
      type: Number
    },
    declaration:{
      type: Object
    }
  },
  methods: {
  }
}
</script>
